import Image from '@components/Image';
import styled from '@emotion/styled';
import { useTranslation } from 'react-i18next';

import img from './img.png';

function PointHeader() {
    const { t } = useTranslation('point');
    return (
        <Container>
            <Card>
                <Image src={img} alt={t('card.imageAlt')}
                    width={192}
                    height={78} />
            </Card>
        </Container>
    );
}

const Container = styled.aside`
    background:  conic-gradient(from 217deg at 50% 50%, rgba(72, 73, 91, 0.60) 0deg, var(--color-primary) 360deg), #FFF;
    padding: 40px 44px 0;
    width: 100%;
`;

const Card = styled.div`
    align-items: center;
    aspect-ratio: 1.7;
    background: var(--color-primary);
    border-radius: 12px 12px 0 0;
    display: flex;
    justify-content: center;
    width: 100%;
`;

export default PointHeader;
